import { styled } from "@mui/material";
import MDBox from "components/Basics/MDBox";

/**
 * Styled component for the Sidenav container
 */
const SidenavContainer = styled(MDBox)(({ theme }) => ({
	width: 220,
	background: theme.palette.background.paper,
	borderRight: `1px solid ${theme.palette.divider}`,
	padding: theme.spacing(1, 0),
	paddingTop: 0,
	marginRight: 14,
	minHeight: 400,
	display: "flex",
	flexDirection: "column",
	alignItems: "stretch"
}));

export default SidenavContainer;
